import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function for combining class names.
 * Uses clsx for conditional class handling and twMerge for intelligent
 * Tailwind CSS class merging (e.g., 'px-2 px-4' becomes 'px-4').
 *
 * @param inputs - Class values to combine
 * @returns Combined class string
 */
export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs));
}
